import type { SxProps, Theme } from "@mui/material/styles";

import { theme } from "@/src/theme/theme";

export const getContainerStyles = (theme: Theme) => ({
  position: "fixed" as const,
  top: { xs: "72px", sm: "80px" },
  left: "50%",
  transform: "translateX(-50%)",
  zIndex: 1100,
  minWidth: { xs: "calc(100% - 32px)", sm: "420px" },
  maxWidth: "540px",
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.semantic.primary.main}`,
  borderRadius: 3,
  boxShadow: `0 8px 24px ${theme.palette.divider}, 0 4px 12px ${theme.palette.action.selected}`,
  padding: { xs: 2.5, sm: 3 },
  transition: "all 0.3s ease-in-out"
});

export const CONTENT_BOX_STYLE = {
  display: "flex",
  flexDirection: "column",
  gap: 2
} as const;

export const HEADER_BOX_STYLE = {
  display: "flex",
  alignItems: "flex-start",
  gap: 2
} as const;

export const getProgressColor = (theme: Theme) => ({
  color: theme.palette.semantic.primary.main,
  flexShrink: 0,
  width: "24px",
  height: "24px"
});

export const TITLE_STYLE: SxProps<Theme> = {
  fontWeight: theme.typography.fontWeightMedium,
  color: theme.palette.text.primary,
  fontSize: {
    xs: theme.typography.buttonLarge.fontSize,
    sm: theme.typography.body1.fontSize
  },
  lineHeight: 1.4,
  textTransform: "none"
};

export const SIZE_TEXT_STYLE: SxProps<Theme> = {
  fontSize: {
    xs: theme.typography.caption.fontSize,
    sm: theme.typography.buttonSmall.fontSize
  },
  color: theme.palette.text.secondary,
  marginTop: 0.5,
  fontWeight: theme.typography.fontWeightRegular
};

export const WARNING_BOX_STYLE = {
  display: "flex",
  alignItems: "center",
  gap: 1,
  padding: 1.25,
  backgroundColor: theme.palette.misc.coldBackground,
  borderRadius: 2,
  border: "1px solid",
  borderColor: theme.palette.divider
} as const;

export const WARNING_ICON_STYLE: SxProps<Theme> = {
  color: theme.palette.text.secondary,
  fontSize: theme.typography.h4.fontSize,
  flexShrink: 0
};

export const WARNING_TEXT_STYLE: SxProps<Theme> = {
  color: theme.palette.text.primary,
  fontSize: {
    xs: theme.typography.caption.fontSize,
    sm: theme.typography.buttonSmall.fontSize
  },
  lineHeight: 1.5,
  fontWeight: theme.typography.fontWeightRegular
};
